import * as PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {apiIdToIconName} from 'util/APIUtil';
import {STAGE_CONFIGURATION_SUMMARY_SHAPE, StageConfigurationSummary} from 'workflows/WorkflowConstants';

function StageEntryTemplateLink(props: StageEntryTemplateLinkProps): JSX.Element {
  return (
    // Link that opens a WorkflowEntryTemplateModal.
    <span className="workflows-internalLinkContainer">
      <span className="internalLink internalLink-content">
        <a onClick={props.onClick}>
          <BenchlingIcon icon={apiIdToIconName(props.stageConfiguration.id)} />
          {props.stageConfiguration.entryTemplateName}
        </a>
      </span>
    </span>
  );
}

interface StageEntryTemplateLinkProps {
  stageConfiguration: StageConfigurationSummary;
  onClick?: () => void;
}

StageEntryTemplateLink.propTypes = {
  stageConfiguration: STAGE_CONFIGURATION_SUMMARY_SHAPE.isRequired,
  onClick: PropTypes.func,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default StageEntryTemplateLink;
